export * from './web-storage'

export * from './__mocks/localstorage-mock'
export * from './__mocks/web-storage.service-mock'



// WEBPACK FOOTER //
// ./src/modules/web-storage/index.ts